import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { H2 } from '@osmosis/tailwind-ui/components/Text';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import React from 'react';

import PopupMenu from '../../PopupMenu';
import { NavListTab } from '@osmosis/shared/types/learndb/learnData';

import useModal from '../../../hooks/useModal';

import { clickable } from '../../../styles/hover';
import { useUserContext } from '../../../context/UserContext';

export type LearnSidenavHeaderProps = {
  title: string;
  selectedTab: NavListTab;
  onSelectTab: (tab: NavListTab) => void;
  tabs: NavListTab[];
};

/**
 * LearnSidenavHeader.
 */
export default function LearnSidenavHeader({
  title,
  selectedTab,
  onSelectTab,
  tabs,
}: LearnSidenavHeaderProps): JSX.Element {
  const popupMenu = useModal();

  const { user } = useUserContext();

  const handleSelectTab = (tab: NavListTab) => {
    onSelectTab(tab);

    popupMenu.hide();
  };

  return (
    <Box
      style={{
        borderBottomColor: 'gray10',
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
      }}
      className={`p-4 `}
    >
      <H2 data-testid="learn-sidenav-header-title">{title}</H2>

      {tabs.length > 1 && user && (
        <Box className={`mt-2 max-w-[fit-content]`}>
          <PopupMenu
            keyExtractor={(item) => item.title}
            isVisible={popupMenu.isVisible}
            hide={popupMenu.hide}
            items={tabs}
            renderItem={(item) => (
              <Flex
                style={{
                  ...clickable('bg-1', 'bg-2'),
                }}
                onClick={() => handleSelectTab(item)}
                data-testid="learn-sidenav-topic-dropdown"
                className={`p-2 items-center justify-between rounded-[8px]`}
              >
                <P>{item.title}</P>
                {item.title === selectedTab.title && (
                  <Box className={`ml-2 text-green-600 dark:text-green-300`}>
                    <Icon icon={faCheck} />
                  </Box>
                )}
              </Flex>
            )}
            showHeader={false}
          >
            <Button
              onClick={popupMenu.toggle}
              variant="transparent"
              endIcon={<Icon icon={faChevronDown} />}
              data-testid="learn-up-next-videos-dropdown"
            >
              {selectedTab.title}
            </Button>
          </PopupMenu>
        </Box>
      )}

      {!user && <P className={`mt-2 font-bold`}>{selectedTab.title}</P>}
    </Box>
  );
}
